export const T = {
  en_GB: {
    title: "Deviation decision",
    accept: "Accept deviation",
    acceptHint: "The advice proceeds; a justification is required and is included in the report.",
    doNotProceed: "Block",
    doNotProceedHint: "The advice stays blocked until the portfolios are adjusted.",
    justificationLabel: "Justification",
    justificationPlaceholder: "Why is this deviation acceptable for the client?",
    save: "Save",
    clearDecision: "Clear decision",
  },
  nb_NO: {
    title: "Avviksbeslutning",
    accept: "Aksepter avvik",
    acceptHint: "Rådgivningen fortsetter; en begrunnelse kreves og inkluderes i rapporten.",
    doNotProceed: "Blokker",
    doNotProceedHint: "Rådgivningen forblir blokkert til porteføljene er justert.",
    justificationLabel: "Begrunnelse",
    justificationPlaceholder: "Hvorfor er dette avviket akseptabelt for kunden?",
    save: "Lagre",
    clearDecision: "Fjern beslutning",
  },
} as const;
